var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 27,
  viewBox: "0 0 22 27",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#0A0A0A",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.334.5a2.5 2.5 0 0 1 1.782.747L18.1 3.262l2.304 2.69A2.5 2.5 0 0 1 21 7.576V24c0 .69-.28 1.315-.732 1.768a2.492 2.492 0 0 1-1.768.732h-15c-.69 0-1.315-.28-1.768-.732A2.492 2.492 0 0 1 1 24V3c0-.69.28-1.315.732-1.768A2.492 2.492 0 0 1 3.5.5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 .5v5a2 2 0 0 0 2 2h4.712",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M5 20.5h12M5 16.5h12M5 12.5h12"
}))));
export default SvgFile;